module.exports = __webpack_public_path__ + "img/ali_app.1bb45aed.svg";